export default "__VITE_ASSET__b28b248a__"